import React, { useEffect, useState } from 'react'
import { Col, Row } from 'antd'
import { getUserClaims } from '../../utils/auth/unified-auth.js';
import { formatDate, returnHyphenIfNull } from "../../utils/utils.js";
import PH_Banner_Logo from '../../assets/PH_Banner_Logo.svg'
import CR_Banner from '../../assets/CR_Banner.svg'

function CommodityPageHeader({ header, subtext, image, subtext2=null, refreshFrequency=null, lastUpdated=null, pageName="", isCategoryForumPage=false, cfLastUpdateValue=null, cfRefreshFrequencyValue=null }) {
    const [userData, setUserData] = useState({})
    const [showBanner, setShowBanner] = useState(true)

    useEffect(() => {
        async function getUserInfo() {
            const userInfo = await getUserClaims()
            if (userInfo) {
                sessionStorage.setItem('userName', userInfo.userName)
                setUserData(userInfo)
            }
        }
        getUserInfo()
    }, []);

    return (
        <>
            <Row gutter={[20, 20]} style={{marginTop:"24px", marginBottom: "24px"}}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                {/* <div style={{display:"flex", justifyContent:"center"}}> */}
                    
                    <div className="commodity_page_banner"> {/* ph-banner class can be added here */}
                            <div className="commodity_page_text" style={{ maxWidth: isCategoryForumPage ? "none" : "580px" }}> 
                                { (header==="PepsiCo Procurement Hub") && <div style={{ fontWeight:700, textTransform: "uppercase" }}>Welcome {userData?.FirstName}</div> }
                                <div style={{display:"flex", alignItems: "center"}}>
                                    {
                                        (header==="PepsiCo Procurement Hub") &&
                                        <img src={PH_Banner_Logo} className="" style={{height: '40px', width:"40px", marginRight: "8px"}}/>
                                    }
                                    <div className="commodity_page_header" style={{}}>{header}</div>
                                </div>
                                {/* <div>{subtext} </div> */}
                                <div>
                                    <div dangerouslySetInnerHTML={{ __html: subtext }}/>
                                    {subtext2 && <div>{subtext2} </div>}
                                </div>
                                {
                                    lastUpdated && 
                                    <div style={{fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "#FFF"}}>Data As On: {returnHyphenIfNull(lastUpdated)} | Refresh Frequency: {returnHyphenIfNull(refreshFrequency)}</div>
                                }
                                {
                                    isCategoryForumPage && (
                                        <>                                          
                                                <div className="cf-contractBoard-lastUpdate" style={{ marginBottom: -10, marginTop: 15 }}>Data As On: {cfLastUpdateValue} | Refresh Frequency: {cfRefreshFrequencyValue}</div>
                                                <div className="cf-contractBoard-lastUpdate" style={{fontStyle: 'italic'}}>Category Forums data refresh takes approximately 5 minutes to complete. During this period, data may be temporarily unavailable</div>
                                        </>
                                    )
                                    
                                }
                            </div>
                            <div style={{ marginLeft:  'auto', width: ''}}>

                                <img src={image} style={{height: "200px", width: "100%", borderRadius: "8px"}} />
                            </div>
                    </div>
                
                {/* </div>     */}




                </Col>
            </Row>

            
        </>
    )
}

export default CommodityPageHeader